import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';

import { colors } from 'styles/cp';

const OutdatedBrowserBanner: React.FC = () => {
  const [dismissed, setDismissed] = useState(false);

  if (dismissed) {
    return null;
  }

  return (
    <div className="outdated-browser-banner" role="alert">
      <div className="outdated-browser-banner__content">
        <span className="outdated-browser-banner__icon">⚠</span>
        <span className="outdated-browser-banner__message">
          <FormattedMessage
            id="OUTDATED_BROWSER_BANNER"
            defaultMessage="Your browser may be out of date. Some features may not work unless you upgrade to the latest version."
          />
        </span>
      </div>
      <button
        className="outdated-browser-banner__close"
        onClick={() => setDismissed(true)}
        aria-label="Close"
      >
        ✕
      </button>

      <style jsx>{`
        .outdated-browser-banner {
          display: flex;
          align-items: center;
          padding: 10px 16px;
          background-color: ${colors.warn};
          color: ${colors.darkBlack};
          font-family: AvenirNextforINTUIT-Regular, 'Helvetica Neue', Arial, sans-serif;
          font-size: 14px;
          line-height: 1.4;
          width: 100%;
          z-index: 1000;
        }

        .outdated-browser-banner__content {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 8px;
          flex: 1;
        }

        .outdated-browser-banner__icon {
          flex-shrink: 0;
          font-size: 16px;
        }

        .outdated-browser-banner__close {
          flex-shrink: 0;
          background: none;
          border: none;
          color: ${colors.darkBlack};
          font-size: 16px;
          cursor: pointer;
          padding: 0 20px;
          margin-left: 8px;
          line-height: 1;
          opacity: 0.7;
        }

        .outdated-browser-banner__close:hover {
          opacity: 1;
        }
      `}</style>
    </div>
  );
};

export default OutdatedBrowserBanner;
